// AVAL Sign — Marches Publics : Custom Element pour graphiques Chart.js.
//
// Usage :
//   <marche-chart data-type="bar"
//                 data-labels='["Jan","Fev"]'
//                 data-datasets='[{"label":"Dossiers","data":[3,5]}]'>
//     <canvas></canvas>
//   </marche-chart>
//
// Type accepted: bar | doughnut | line | pie
export default class extends HTMLElement {
  connectedCallback () {
    this.chartType = this.dataset.type || 'bar'
    this.chartLabels = JSON.parse(this.dataset.labels || '[]')
    this.chartDatasets = JSON.parse(this.dataset.datasets || '[]')
    this.showLegend = this.dataset.legend !== 'false'

    this.initChart()
  }

  disconnectedCallback () {
    if (this.chartInstance) {
      this.chartInstance.destroy()
      this.chartInstance = null
    }
  }

  async initChart () {
    const { default: Chart } = await import(/* webpackChunkName: "chartjs" */ 'chart.js/auto')

    const canvas = this.querySelector('canvas')
    if (!canvas) return

    const ctx = canvas.getContext('2d')

    const isRadial = this.chartType === 'doughnut' || this.chartType === 'pie'

    this.chartInstance = new Chart(ctx, {
      type: this.chartType,
      data: {
        labels: this.chartLabels,
        datasets: this.chartDatasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: 400 },
        plugins: {
          legend: {
            display: this.showLegend,
            position: isRadial ? 'right' : 'top',
            labels: { font: { size: 12 }, boxWidth: 12, padding: 12 }
          },
          tooltip: {
            backgroundColor: 'rgba(17, 24, 39, 0.95)',
            titleFont: { size: 13, weight: '600' },
            bodyFont: { size: 12 },
            padding: 10,
            cornerRadius: 6
          }
        },
        scales: isRadial
          ? {}
          : {
              y: {
                beginAtZero: true,
                grace: '15%',
                ticks: { precision: 0, font: { size: 11 } },
                grid: { color: 'rgba(0,0,0,0.06)' }
              },
              x: {
                ticks: { font: { size: 11 } },
                grid: { display: false }
              }
            }
      }
    })
  }
}
